var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReportData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.746,
    height: 135.44,
    viewBox: "0 0 185.746 135.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_51944",
    "data-name": "Group 51944",
    transform: "translate(-95 -728)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1293",
    "data-name": "Ellipse 1293",
    cx: 3.802,
    cy: 3.802,
    r: 3.802,
    transform: "translate(138.449 780.129)",
    fill: "#f45e29"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1297",
    "data-name": "Ellipse 1297",
    cx: 3.802,
    cy: 3.802,
    r: 3.802,
    transform: "translate(273.142 804.967)",
    fill: "#80cc8c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1298",
    "data-name": "Ellipse 1298",
    cx: 3.802,
    cy: 3.802,
    r: 3.802,
    transform: "translate(152.57 728.296)",
    fill: "#80cc8c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1295",
    "data-name": "Ellipse 1295",
    cx: 3.802,
    cy: 3.802,
    r: 3.802,
    transform: "translate(232.951 770.41)",
    fill: "#f4982d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1296",
    "data-name": "Ellipse 1296",
    cx: 3.802,
    cy: 3.802,
    r: 3.802,
    transform: "translate(95 809.286)",
    fill: "#f4982d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M4.345,0,8.69,7.6H0Z",
    transform: "translate(125.725 813.018) rotate(30)",
    fill: "#4482ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_4",
    "data-name": "Polygon 4",
    d: "M4.345,0,8.69,7.6H0Z",
    transform: "translate(267.788 749.889) rotate(30)",
    fill: "#97a9b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_5",
    "data-name": "Polygon 5",
    d: "M4.345,0,8.69,7.6H0Z",
    transform: "translate(213.923 734.145) rotate(-45)",
    fill: "#e46179"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53384",
    "data-name": "Path 53384",
    d: "M815.793,233.954a.749.749,0,0,0,.473-.588l1.576-10.45a.749.749,0,0,0-1.123-.755l-8.909,5.294a.749.749,0,0,0-.1,1.22l2.021,1.673a.749.749,0,1,0,.955-1.154l-1.2-1,6.637-3.944-1.143,7.579-1.176-.972a.749.749,0,0,0-.786-.1l-.733.331,1.4-1.68a.749.749,0,1,0-1.151-.957l-3.476,4.181a.749.749,0,0,0,.884,1.161l3.27-1.479,1.835,1.517a.748.748,0,0,0,.745.122Z",
    transform: "translate(-635.321 536.47)",
    fill: "#f45e29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70460",
    "data-name": "Path 70460",
    d: "M813.754,231.048a.566.566,0,0,0,.357-.444l1.191-7.9a.566.566,0,0,0-.849-.571l-6.733,4a.566.566,0,0,0-.072.922l1.527,1.264a.566.566,0,0,0,.722-.872l-.909-.752L814,223.714l-.864,5.728-.889-.734a.566.566,0,0,0-.594-.079l-.554.25,1.056-1.27a.566.566,0,1,0-.87-.723l-2.627,3.16a.566.566,0,0,0,.668.877l2.472-1.118,1.387,1.147a.565.565,0,0,0,.563.092Z",
    transform: "translate(-559.959 592.624)",
    fill: "#edb25c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70461",
    "data-name": "Path 70461",
    d: "M813.754,231.048a.566.566,0,0,0,.357-.444l1.191-7.9a.566.566,0,0,0-.849-.571l-6.733,4a.566.566,0,0,0-.072.922l1.527,1.264a.566.566,0,0,0,.722-.872l-.909-.752L814,223.714l-.864,5.728-.889-.734a.566.566,0,0,0-.594-.079l-.554.25,1.056-1.27a.566.566,0,1,0-.87-.723l-2.627,3.16a.566.566,0,0,0,.668.877l2.472-1.118,1.387,1.147a.565.565,0,0,0,.563.092Z",
    transform: "translate(-698.996 531.986)",
    fill: "#97a9b7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51943",
    "data-name": "Group 51943",
    transform: "translate(-5270.945 490)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46830",
    "data-name": "Group 46830",
    transform: "translate(5419.233 352.068) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17465",
    "data-name": "Rectangle 17465",
    width: 45.068,
    height: 70.891,
    rx: 2,
    transform: "translate(0 4.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17465_-_Outline",
    "data-name": "Rectangle 17465 - Outline",
    d: "M1.66,1.3a.65.65,0,0,0-.581.7V68.891a.65.65,0,0,0,.581.7H43.409a.65.65,0,0,0,.581-.7V2a.65.65,0,0,0-.581-.7H1.66m0-1.3H43.409a1.854,1.854,0,0,1,1.66,2V68.891a1.854,1.854,0,0,1-1.66,2H1.66a1.854,1.854,0,0,1-1.66-2V2A1.854,1.854,0,0,1,1.66,0Z",
    transform: "translate(0 4.767)",
    fill: "#3d4246"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17466",
    "data-name": "Rectangle 17466",
    width: 37.662,
    height: 63.558,
    rx: 2,
    transform: "translate(3.703 8.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17466_-_Outline",
    "data-name": "Rectangle 17466 - Outline",
    d: "M1.606,1.3a.643.643,0,0,0-.562.7V61.558a.643.643,0,0,0,.562.7H36.057a.643.643,0,0,0,.562-.7V2a.643.643,0,0,0-.562-.7H1.606m0-1.3H36.057a1.836,1.836,0,0,1,1.606,2V61.558a1.836,1.836,0,0,1-1.606,2H1.606a1.836,1.836,0,0,1-1.606-2V2A1.836,1.836,0,0,1,1.606,0Z",
    transform: "translate(3.703 8.434)",
    fill: "#3d4246"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51940",
    "data-name": "Group 51940",
    transform: "translate(-65 -30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72326",
    "data-name": "Path 72326",
    d: "M5427.5,345.217l13.327-7.588,14.679,4.961,11.976-12.841",
    transform: "translate(77.156 22.318)",
    fill: "none",
    stroke: "#f45e29",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1409",
    "data-name": "Ellipse 1409",
    transform: "translate(5503 363)",
    fill: "#fff",
    stroke: "#f45e29",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.375,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1410",
    "data-name": "Ellipse 1410",
    transform: "translate(5516 357)",
    fill: "#fff",
    stroke: "#f45e29",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.375,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1412",
    "data-name": "Ellipse 1412",
    transform: "translate(5540 350)",
    fill: "#fff",
    stroke: "#f45e29",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.375,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1413",
    "data-name": "Ellipse 1413",
    transform: "translate(5530 361)",
    fill: "#fff",
    stroke: "#f45e29",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.375,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51942",
    "data-name": "Group 51942",
    transform: "translate(5431.5 314.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72323",
    "data-name": "Path 72323",
    d: "M340.5,374.481a1.273,1.273,0,0,1-1.273-1.273V356.663a1.273,1.273,0,0,1,2.546,0v16.545A1.273,1.273,0,0,1,340.5,374.481Z",
    transform: "translate(-312.503 -317.524)",
    fill: "#fff",
    stroke: "#202124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72324",
    "data-name": "Path 72324",
    d: "M254.352,462.491a1.272,1.272,0,0,1-.765-2.29l10.182-7.637A1.272,1.272,0,1,1,265.3,454.6l-10.182,7.637A1.266,1.266,0,0,1,254.352,462.491Z",
    transform: "translate(-239.867 -404.158)",
    fill: "#fff",
    stroke: "#202124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72325",
    "data-name": "Path 72325",
    d: "M350.68,462.488a1.266,1.266,0,0,1-.763-.255L339.736,454.6a1.272,1.272,0,1,1,1.527-2.036l10.182,7.636a1.273,1.273,0,0,1-.765,2.291Z",
    transform: "translate(-309.166 -404.154)",
    fill: "#fff",
    stroke: "#202124",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportData);
export default __webpack_public_path__ + "static/media/icon-report-data.bc3176f6.svg";
export { ForwardRef as ReactComponent };